"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  custom: '自定义',
  inputErrorTip: '输入不是有效值',
  dateErrorTip: '当前值不合法',
  nullableErrorTip: '不能为空',
  chooseTodayNow: '今时此刻',
  chooseThisMonth: '本月',
  rangeErrorTip: '超出可选择范围',
  maxRangeErrorTip: '超出最大范围',
  minRangeErrorTip: '小于最小范围',
  startGreaterThanEndTip: '起始时间不得大于结束时间',
  confirm: '确定',
  placeholder: '选择日期',
  placeholderRangeStart: '开始时间',
  placeholderRangeEnd: '结束时间',
  chooseTipRangeStart: '选择开始时间',
  chooseTipRangeEnd: '选择结束时间'
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/DatePicker/locale/zh_CN.js
// module id = 1398
// module chunks = 6 7 17 18